// extracted by mini-css-extract-plugin
module.exports = {"servicesRating":"src-components-results-Hotel-Rating-styles__servicesRating","rating":"src-components-results-Hotel-Rating-styles__rating"};